module.exports = __webpack_public_path__ + "img/Connect.f0475198.svg";